<template>
	<div class="basic_wrap">
		<div class="top">
			<img src="../images/ban2/logo.svg">
		</div>
		<div class="form">
			<div class="title">Login atau buat akun </div>
			<div class="subdesc">
				Buka dunia perjalanan dengan satu akun di Expedia, Hotels.com, dan Vrbo.
			</div>
		</div>
		<div class="form">
			<div class="item">
				<span class="icon">
					<van-icon name="user-o" size="25"/>
				</span>
				<input v-model.trim="data.unanme" @input="chageuname" type="text" class="inp"
					:placeholder="$t('register.inunanme')">
			</div>
			
		<!-- 	<div class="item sms" v-if="app.isinvest==1">
				<span class="icon">
					<van-icon name="guide-o" size="25"/>
				</span>
				<input maxlength="6" v-model.trim="data.code" type="text" class="inp"
					:placeholder="$t('register.smscode')">
				<van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
				    <template v-slot="timeData">
				        <span @click="sendcode" >{{timeData.seconds > 0 ? (timeData.seconds) : $t('register.sendCode')}}</span>
				    </template>
				</van-count-down>	
			</div> -->
		
			<div class="item">
				<span class="icon">
					<van-icon name="lock" size="25"/>
				</span>
				<input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('register.password')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>
			<div class="item">
				<span class="icon">
					<van-icon name="lock" size="25"/>
				</span>
				<input v-model.trim="data.spassword" :type="password" class="inp" :placeholder="$t('register.spassword')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>
			<!-- <div class="item">
				<span class="icon">
					<van-icon name="user-circle-o" size="25"/>
				</span>
				<input v-model.trim="data.tname" type="text" class="inp" :placeholder="$t('feng.inuname')">
			</div>
			<div class="item">
				<span class="icon">
					<van-icon name="shield-o" size="25"/>
				</span>
				<input maxlength="6" v-model.trim="data.paypwd" :type="password" class="inp"
				@click="write_psd = true;"
					:placeholder="$t('register.paypwd')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>
			<div class="item">
				<span class="icon">
					<van-icon name="phone-o" size="25"/>
				</span>
				<input v-model.trim="data.mobile" type="number" class="inp" :placeholder="$t('register.phoneNumber')">
			</div> -->
			<template >
				<div class="item">
					<span class="icon">
						<van-icon name="friends-o" size="25"/>
					</span>
					<input v-model.trim="data.t_mobile" type="text" class="inp"
						:placeholder="$t('register.referralCode')">
				</div>
			</template>
			<!-- <template >
				<div class="item">
					<span class="icon">
						<van-icon name="guide-o" size="25"/>
					</span>
					<input v-model.trim="data.telacc" type="text" class="inp"
						:placeholder="$t('register.telacc')">
				</div>
			</template> -->
			<div class="basic_btn sbtn" :class="
			  data.mobile == '' ||
			    data.password == '' ||
					data.unanme == '' ||
						data.t_mobile == '' ||
					  data.paypwd == ''
			    ? 'no_touch'
			    : ''
			" @click="submit">
						{{$t('register.signUpBtn')}}
					</div>
			<div class="geli">
				<div class="geli1"></div>
				<span class="gelitext">{{$t('pro2.atau')}}</span>
				<div class="geli2"></div>
			</div>
			<div @click="$router.push('/login')" class="cont_textCon_but cont_textCon_but1 flexCenter">
				{{$t('login.signInBtn')}}
			</div>		
			<!-- <div @click="$router.push('/login')"
				class="basic_btn sbtn">
				{{$t('login.signIn')}}
			</div>	 -->
			<!-- <p  class="tip">
				{{$t('feng.hadacc')}}
				<a @click="$router.push('/login')">{{$t('feng.gologin')}}</a>
			</p> -->
		</div>
		
		<div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
			<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
			<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
			<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
		</div>
		
		
		<van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="privacyStatementHide">
		</van-dialog>
		<van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
			@click="agreementHider">
		</van-dialog>
	<!-- 	<div v-if="msg_show && app" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<a v-if="show_kefu" :href="app.kefu_link" target="_blank">
				<img class="kefu_img" src="../images/shop2/kefu.png">
			</a>
			<img v-if="!show_kefu" class="kefu_img" src="../images/shop2/kefu.png">
		</div> -->
		
		
		<van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
		    <div class="psw_box">
		        <van-password-input :value="psd_val" :mask="true" :focused="showKeyboard" @focus="showKeyboard = true" />
		        <div class="keybord_box">
		            <div class="keybord">
		                <div class="key_item" v-for="i in 9" @click="onInput(i)">
		                    <div class="key_inner">{{i}}</div>
		                </div>
		                <div class="key_item no_bg">
		                    <div class="key_inner"></div>
		                </div>
		                <div class="key_item" @click="onInput(0)">
		                    <div class="key_inner">0</div>
		                </div>
		                <div class="key_item no_bg x" @click="onDelete">
		                    <div class="key_inner">x</div>
		                </div>
		            </div>
		        </div>
		    </div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		DropdownMenu,
		DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		ActionSheet,
		Icon,
		CountDown,
		Checkbox,
		Dialog
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Checkbox)
		.use(Icon)
		.use(Dialog).use(PasswordInput)
		.use(NumberKeyboard).use(Popup)
		.use(DropdownMenu).use(DropdownItem).use(ActionSheet);

	export default {
		name: "Register",
		data() {
			return {
				time: 0,
				showKeyboard: true,
				agreement: false,
				write_psd: false,
				psd_val: '',
				lang:this.$i18n.locale||"en_us",
				statement: false,
				show_kefu: false,
				msg_show: true,
				show_sms: 0,
				app: null,
				password: "password",
				data: {
					password: "",
					spassword: "",
					paypwd: "",
					mobile: "",
					t_mobile: "",
					tname:"",
					unanme: "",
					code: "",
					agent: 10000
				},
				config: {}
			};
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
			// 安卓返回IMEI，苹果返回UID值
			/*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
		},
		mounted() {
			this.start();
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		methods: {
			chageuname(){
				var input = this.data.unanme;
				var stringWithoutLeadingDigit = input.replace(/^\d+/, '');
				  // 去掉字符串中的空格
				this.data.unanme = stringWithoutLeadingDigit.replace(/\s+/g, '');
			},
			onInput(key) {
			    this.psd_val = (this.psd_val + key).slice(0, 6);
			    if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.data.paypwd = this.psd_val;
					// if(this.submitType==1){
					// 	this.submit();
					// }else{
					// 	this.setIniPwdSubmit();
					// }
					
			    }
			},
			onDelete() {
			    this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
			},
			start() {
				Fetch("/index/webconfig").then((r) => {
					this.app = r.data;
				});
			},
			kefu_to() {
				this.show_kefu = !this.show_kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				if(m && parseInt(m)>0){
					localStorage.setItem('t_mobile', m);
					this.data.t_mobile = m;
				}else{
					if (localStorage.getItem('t_mobile')) {
						this.data.t_mobile = localStorage.getItem('t_mobile');
					}else{
						if (localStorage.getItem('agent')) {
							this.data.t_mobile = localStorage.getItem('agent');
						}
					}
				}
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						mobile: this.data.mobile,
					}).then(() => {
						this.time = 60 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					}).catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if(!this.data.unanme){
					this.$toast(this.$t('feng.unamerr'));
					return false;
				}
				if (!this.data.password) {
					this.$toast(this.$t('register.password'));
					return false;
				}
				if (!this.data.spassword) {
					this.$toast(this.$t('register.spassword'));
					return false;
				}
				if (this.data.password != this.data.spassword) {
				    this.$toast(this.$t('register.passwordError'));
				    return false;
				}
				// if (!this.data.mobile) {
				// 	this.$toast(this.$t('register.phoneEmpty'));
				// 	return false;
				// }
				// if (!this.data.tname) {
				// 	this.$toast(this.$t('feng.inuname'));
				// 	return false;
				// }
				// if (!this.data.paypwd) {
				// 	this.$toast(this.$t('feng.set6pwd'));
				// 	return false;
				// }
				if (!this.data.code && this.config.sms_verify) {
					this.$toast(this.$t('register.codeEmpty'));
					return false;
				}
				
				// if (!/^\d{7,11}$/.test(this.data.mobile)) {
				//     this.$toast(this.$t('login.phoneError'));
				//     return false;
				// }
				Fetch("/index/register", {
					password: this.data.password,
					spassword: this.data.spassword,
					paypwd: this.data.paypwd,
					// mobile: this.data.mobile,
					mobile: this.data.unanme,
					t_mobile: this.data.t_mobile,
					unanme: this.data.unanme,
					// tname: this.data.tname,
					tname: this.data.unanme,
					code: this.data.code,
					agent: this.data.agent
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast(this.$t('register.signUpSuccess'));
					this.$router.replace("/");
				});
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
			changeLang(lang,event) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			}
		},
	};
</script>

<style lang="less" scoped>
	.login_bg {
		width: 100%;
		height: 48px;
		background: #0064d3;
		background-size: 100% 100%;
		overflow: hidden;
		.language{
			position: absolute;
			top: 4px;
			right: 0;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}

	.basic_wrap .form {
		margin: 0px auto 0 auto;
		width: 100%;
		box-shadow:none;
		border-radius: 13px;
		padding: 2vh 5vw;
		background: none;
	}

	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;
		a {
			width: 50%;
			padding-bottom: 10px;
			color: #ceced0;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
			}
		}

		a.cur {
			color: #0063d2;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #0063d2, #f18a11);
			}
		}
	}
	.big_tit{
		color: #FFFFFF;
	}
	.block {
		width: 100%;
		height: 100%;
		// overflow:hidden;
		// margin: 10% auto;
		font-size: 15px;
		justify-content: center;
		background-color: #fff;
		border-radius: 5px;

		.block-title {
			display: block;
			font-weight: bolder;
			line-height: 39px;
			height: 39px;
			text-align: center;
		}

		.p_agr {
			// padding-top:30rpx;
			font-size: 12px;
			/*font-weight: bolder;*/
			line-height: 20px;
			padding: 0px 10px;
			height: 388px;
			/*overflow: hidden;*/
			// overflow: auto;
			-webkit-overflow-scrolling: touch;
			overflow-y: scroll;
		}

		.div_qd {
			width: 60px;
			height: 25px;

			span {
				width: 60px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				justify-content: center;
				background: #fb661e;
				border-radius: 10px;
				padding: 1px 5px;
				color: #fff;
			}

			margin: 10px auto;
		}
	}

	.item {
		height: 55px;
		border-bottom:1px solid #e4e4e4;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;
		.icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 28px;
			height: 24px;

			.people {
				width: 23px;
				height: 20px;
			}

			img {
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			margin-bottom: 3px;
		}
	}

	.get_captcha {
		width: 88px;
		height: 34px;
		background: linear-gradient(90deg,
				rgba(228, 57, 46, 1) 0%,
				rgba(254, 76, 22, 1) 100%);
		border-radius: 4px;
		text-align: center;
		line-height: 34px;
		font-size: 14px;
		color: #ffffff;
	}

	.protocol {
		font-size: 12px;
		line-height: 17px;
		margin-top: 20px;
		color: #999999;

		a {
			color: #3d96ff;
		}
	}

	.basic_btn {
		margin: 10% auto 0 auto;
	}
	/deep/ .van-icon {
	    color: #000;
		font-size: 20px !important;
	}
	h2.page-title{
		font-size: 25px;
		font-weight: 700;
		color: #0063d2;
		padding: 2vh 5vw;
	}
	h3.page-title{
		color: #727d91;
		font-weight: 400;
		padding: 2vh 5vw;
		padding-top: 0;
	}
	.van-field__label{
		-webkit-box-flex: 0;
		-webkit-flex: none;
		flex: none;
		box-sizing: border-box;
		width: 24vw;
		margin-right: 3.2vw;
		color: #646566;
		text-align: left;
		word-wrap: break-word;
		width: 100%;
		font-size: 3.73333vw;
		color: #727d91;
	}
	#appLogo{
	/deep/  .icon .van-icon{
		color: #FFF !important;
	}
	/deep/ .van-checkbox__label{
		color: #FFF !important;
	}
		display: block;
		width: 35%;
		margin: 0.5rem auto 0;
	}
	/deep/ .van-password-input {
	    margin: 50px 28px 0 28px;
	}
	
	/deep/ .van-hairline--left::after {
	    border: 1px solid #ECECEC;
	}
	
	.van-password-input .van-password-input__security::after {
	    border-radius: 0;
	}
	
	.keybord_box {
	    height: 250px;
	    background-color: #F0F0F0;
	    margin-top: 35px;
	    padding: 24px 12px 0 12px;
	
	    .keybord {
	        width: 361px;
	        margin: 24px auto 0 atuo;
	        display: flex;
	        justify-content: space-between;
	        flex-wrap: wrap;
	        text-align: center;
	
	        .key_item {
	            width: 115px;
	            height: 44px;
	            line-height: 44px;
	            font-size: 18px;
	            font-weight: bold;
	            margin-bottom: 6px;
	            background: rgba(255, 255, 255, 1);
	            border-radius: 3px;
	
	            &.no_bg {
	                background: none;
	            }
	
	            &.x {
	                color: #757880;
	                font-weight: bold;
	            }
	        }
	    }
	}
	.tip{
		text-align: left;
		line-height: 30px;
		font-size: 14px;
		color: #666;
		margin-top: 10px;
		padding-bottom: 10vh;
		a{
			color: #0063d2;
			text-decoration: underline;
		}
	}
	.topbaner{
		width: 100%;
	}
	.bottomImg{
		display: flex;
		justify-content: center;
		margin-top: 57px;
		img{
			width: 320px;
		}
	}
	.basic_btn{
		font-weight: bold;
		height: 39px;
		line-height: 39px;
		border-radius: 36px;
		font-size: 15px;
	}
	.top{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 8px;
		margin-top: 5px;
		img{
			height: 35px;
		}
		.topt{
			font-size: 14px;
			line-height: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 4px;
		}
	}
	.geli{
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px;
		.geli1{
			width: 32px;
			border-color: #aeb2be;
			border-top: 1px solid #d8dce8;
			margin-right: 8px!important;
		}
		.gelitext{
			font-size: 12px;
			line-height: 16px;
			margin-right: 8px!important;
			color: #71747d;
		}
		.geli2{
			width: 32px;
			border-color: #aeb2be;
			border-top: 1px solid #d8dce8;
		}
	}
	.basic_wrap{
		// background-image: url(../images/ban1/bg.png);
		background-size: cover;
		background-position: center center;
	}
	.footimgs{
		height: 25px;
		margin: 0 5px;
	}
	.form{
		.title{
			margin-top: 30px;
			font-size: 18px;
			line-height: 30px;
			font-weight: bold;
			color: #000;
		}
		.subdesc{
			margin-top: 10px;
			font-size: 12px;
			line-height:20px;
		}
	}
	.cont_textCon_but1 {
		height: 39px;
		border-radius: 36px;
		font-size: 15px;
		font-weight: bold;
	    background: #fff;
	    color: #0063d2;
	    border: 1px solid #0063d2;
	    margin-top: 15px;
		background: #0063d2 !important;
		color: #fffffd !important;
	}
	.flexCenter {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
</style>
